import * as api from '../api/vouchers.js';
import q from '../query.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const voucherTypesEntity = `voucher-types`;
export const voucherTypesKey = 'voucher-types';
export const useVoucherTypes = () => q.query(voucherTypesKey, api.getTypes, keys.read.collection(voucherTypesEntity));
//# sourceMappingURL=index.js.map